import { Dispatch } from 'redux'
import { fetchAccountSummary, fetchCustomerDetails, updateCustomerDetails } from '../apis/accountSummaryApi'
import { Action, ActionType } from '../types/accountSummaryType'

export const getAccountSummary = () => {
  return async (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.GET_ACCOUNT_SUMMARY_PENDING
    })
    try {
      const success = await fetchAccountSummary()
      dispatch({
        type: ActionType.GET_ACCOUNT_SUMMARY_SUCCESS,
        payload: success
      })
    } catch (_err) {
      dispatch({
        type: ActionType.GET_ACCOUNT_SUMMARY_FAIL
      })
    }
  }
}

export const resetAccountSummary = () => {
  return async (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.RESET
    })
  }
}

export const getCustomerDetails = () => {
  return async (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.GET_CUSTOMER_PENDING
    })
    try {
      const success = await fetchCustomerDetails()
      dispatch({
        type: ActionType.GET_CUSTOMER_SUCCESS,
        payload: success.customer
      })
    } catch (_err) {
      dispatch({
        type: ActionType.GET_CUSTOMER_FAIL
      })
    }
  }
}

export const editCustomerDetails = (customer: {
  name?: string
  surname?: string
  telephone?: string
  password?: string
  billing?: any
  payment?: any
  intent?: any
  emailMarketing?: boolean
  smsMarketing?: boolean
  mailConsentFirstParty?: boolean
  mailConsentThirdParty?: boolean
  marketingCookieConsent?: boolean
  referrer?: string
}) => {
  return async (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.UPDATE_CUSTOMER_PENDING
    })
    try {
      customer.marketingCookieConsent = window?.Cookiebot?.consent?.marketing
      await updateCustomerDetails(customer)
      dispatch({
        type: ActionType.UPDATE_CUSTOMER_SUCCESS
      })
    } catch (err) {
      if (err.data.status === 'requires_action') {
        dispatch({
          type: ActionType.REQUIRES_3D_SECURE,
          payload: err.data.payment
        })
      } else {
        dispatch({
          type: ActionType.UPDATE_CUSTOMER_FAIL,
          payload: err.data
        })
      }
    }
  }
}
